import { AxiosInstance } from 'axios';
import { getResourceUrl } from '../utils';
import config from 'config';

export default function remove(ajax: AxiosInstance) {
  const performDelete = (url: string) => {
    return ajax({
      url,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((results) => {
      return {
        data: results.data,
      };
    });
  };

  return (resource, { id, company_id, previousData }) => {
    const { kind } = previousData || {};
    const baseUrl = getResourceUrl(resource, id);
    switch (resource) {
      case 'ApplicationRequirement':
      case 'BillingContact':
      case 'Check':
      case 'ClinicalContact':
      case 'Credential':
      case 'CustomProfessionalProfileEhrSystem':
      case 'Education':
      case 'EmergencyContact':
      case 'ExpenseAdjustment':
      case 'InterviewAvailability':
      case 'Invoice':
      case 'ItemizedTransaction':
      case 'JobTemplate':
      case 'LeadPosition':
      case 'LeadSpecialty':
      case 'LicenseField':
      case 'LocationConnection':
      case 'LocationPosition':
      case 'LocationPositionRateSetting':
      case 'LocationTypePosition':
      case 'MarketLocationTypePositionRateSetting':
      case 'MarketPositionRateSetting':
      case 'MarketRateSetting':
      case 'Note':
      case 'PositionCertification':
      case 'PositionLicense':
      case 'PositionPostingField':
      case 'PositionSpecialty':
      case 'ProfessionalPosition':
      case 'ProfessionalProfileEhrSystem':
      case 'ProfessionalReference':
      case 'ProfessionalSpecialty':
      case 'Relationship':
      case 'Requirement':
      case 'RevenueAdjustment':
      case 'SkillsAssessmentResponse':
      case 'StatePositionRateSetting':
      case 'StateRateSetting':
      case 'StateLocationTypeRateSetting':
      case 'UserPosition':
      case 'UserPositionLicense':
      case 'UserPositionRateSetting':
      case 'UserRateSetting':
      case 'WorkGap':
      case 'WorkHistory':
        return performDelete(baseUrl);
      case 'ApprovalGroup':
        return performDelete(`${config.rails_url}/v3/admin/companies/${company_id}/approval_groups/${id}`);
      case 'Job':
        if (kind === 'time_off') {
          return performDelete(`${config.rails_url}/v3/admin/jobs/time_off/${id}`);
        }
        return Promise.reject('Not allowed to delete jobs except time off jobs');
      case 'LocationGroup':
        return performDelete(`${config.rails_url}/v3/admin/companies/${company_id}/group_nodes/${id}`);
      case 'PermanentRequest':
        return performDelete(`${config.rails_url}/v3/admin/assignment_requests/${id}`);
      default:
        return Promise.reject(`Not allowed to delete resource ${resource}`);
    }
  };
}
